export default __webpack_public_path__ + "static/media/pokemon_not_found.13308573.png";